import axios from 'axios';

/**
 * Call Azure OpenAI API directly using provided credentials and messages.
 * @param {Object} credentials - Object containing endpoint, apiKey, deploymentName
 * @param {Array} messages - Array of message objects {role, content}
 * @returns {Promise<string>} - The content of the assistant's response
 */
export const callAzureOpenAI = async (credentials, messages) => {
    if (!credentials || !credentials.endpoint || !credentials.apiKey || !credentials.deploymentName) {
        throw new Error('Invalid Azure credentials provided');
    }

    const { endpoint, apiKey, deploymentName } = credentials;

    // Construct the full URL
    // Typically: https://{resource}.openai.azure.com/openai/deployments/{deployment}/chat/completions?api-version={version}
    const apiVersion = '2024-08-01-preview'; // Using a recent stable-preview version, can be adjusted
    // If the endpoint provided is just the base (e.g. https://amalgamateopenai.openai.azure.com), construct full path
    // If it already has path, use valid logic. 
    // Based on user curl response: "endpoint": "https://amalgamateopenai.openai.azure.com"

    const baseUrl = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint;
    const url = `${baseUrl}/openai/deployments/${deploymentName}/chat/completions?api-version=${apiVersion}`;

    try {
        const response = await axios.post(
            url,
            {
                messages: messages,
                temperature: 0.7,
                max_tokens: 800,
                top_p: 0.95,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': apiKey,
                },
            }
        );

        if (
            response.data &&
            response.data.choices &&
            response.data.choices.length > 0 &&
            response.data.choices[0].message
        ) {
            console.log('Azure OpenAI response:', response.data);
            return response.data.choices[0].message.content;
        } else {
            throw new Error('No response content from Azure OpenAI');
        }
    } catch (error) {
        console.error('Error calling Azure OpenAI:', error);
        throw error;
    }
};
